var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('h3',[_vm._v("Use share token:")]),_c('InputText',{attrs:{"name":"Share Token","required":""},model:{value:(_vm.shareToken),callback:function ($$v) {_vm.shareToken=$$v},expression:"shareToken"}}),_c('b-button',{on:{"click":_vm.submit}},[_vm._v("Submit")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }